module.exports = __webpack_public_path__ + "static/img/num3.eb02e746.png";